(() => {
  const CARD_SELECTOR = '[data-kp-story-card]';
  const PLAY_SELECTOR = '[data-kp-story-play]';

  const resetCard = (card, resetTime = false) => {
    const video = card?.querySelector('.kp-story-video');

    if (!video) return;

    video.pause();
    video.controls = false;
    card.classList.remove('is-playing');

    if (resetTime) {
      try {
        video.currentTime = 0;
      } catch (error) {
        // Some browsers prevent seeking before metadata loads.
      }
    }
  };

  const pauseOtherStoryVideos = (activeVideo) => {
    document
      .querySelectorAll(`${CARD_SELECTOR} .kp-story-video`)
      .forEach((video) => {
        if (video !== activeVideo) {
          resetCard(video.closest(CARD_SELECTOR));
        }
      });
  };

  document.addEventListener('click', async (event) => {
    const playButton = event.target.closest(PLAY_SELECTOR);

    if (!playButton) return;

    const card = playButton.closest(CARD_SELECTOR);
    const video = card?.querySelector('.kp-story-video');

    if (!card || !video) return;

    pauseOtherStoryVideos(video);

    video.controls = true;
    card.classList.add('is-playing');

    try {
      await video.play();
    } catch (error) {
      video.controls = false;
      card.classList.remove('is-playing');

      console.warn('The story video could not be played.', error);
    }
  });

  document.addEventListener(
    'ended',
    (event) => {
      if (
        !event.target.matches?.(
          `${CARD_SELECTOR} .kp-story-video`
        )
      ) {
        return;
      }

      resetCard(
        event.target.closest(CARD_SELECTOR),
        true
      );
    },
    true
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      event.target
        .querySelectorAll?.(
          `${CARD_SELECTOR} .kp-story-video`
        )
        .forEach((video) => {
          resetCard(video.closest(CARD_SELECTOR));
        });
    }
  );
})();